import { ProcedureType, ProcedureVersionStatus } from "@prism/prism-shared";

export interface ProcedureVersion {
    id: string;
    procedureId: string;
    name: string;
    description: string;
    status: ProcedureVersionStatus;
    versionNumber: number | null;
    prefaceMarkdown: string;
    steps: ProcedureVersionStep[];
    createdById: string;
    createdOn: Date;
    updatedById: string;
    updatedOn: Date;
    releasedById: string | null;
    releasedOn: Date | null;
    releaseComment: string | null;
}


export interface ProcedureVersionStep{
    id: string;
    title: string;
    markdown: string;
    userInputs: ProcedureVersionStepUserInput[];
    linkedProcedureId?: string;
}

export interface ProcedureLinkSummary {
    procedureId: string;
    procedureVersionId: string;
    name: string;
    versionNumber: number | null;
}


export interface ProcedureVersionStepUserInput{
    id: string;
    name: string;
    type: ProcedureVersionStepUserInputType;
    value: string;
    required: boolean;
}

export enum ProcedureVersionStepUserInputType{
    Text = 'Text',
    Number = 'Number',
    File = 'File'
}
